var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _polygon, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrj1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2880 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2848,1568h-421.01v-604.21h421.01v604.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.58,963.04h317.06s0-931.04,0-931.04h-226.48s0,843.19,0,843.19h-90.58s0,87.84,0,87.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2295.85,963.79h-449.13c-48.54,0-88.25,10.68-88.25,23.74v557.47c0,13.06,39.71,23.74,88.25,23.74h449.13c48.54,0,88.25-10.68,88.25-23.74v-557.47c0-13.06-39.71-23.74-88.25-23.74ZM2098.44,1386.19c0,2.6-7.9,4.72-17.55,4.72h-19.22c-9.65,0-17.55-2.12-17.55-4.72v-239.83c0-2.6,7.9-4.72,17.55-4.72h19.22c9.65,0,17.55,2.12,17.55,4.72v239.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M481.48,32H106.64c-40.51,0-73.65,10.13-73.65,22.5v528.44c0,12.38,33.14,22.5,73.65,22.5h374.84c40.51,0,73.65-10.13,73.65-22.5V54.5c0-12.38-33.14-22.5-73.65-22.5ZM316.73,432.39c0,2.46-6.59,4.48-14.65,4.48h-16.04c-8.06,0-14.65-2.01-14.65-4.48v-227.34c0-2.46,6.59-4.48,14.65-4.48h16.04c8.06,0,14.65,2.01,14.65,4.48v227.34Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.33,
    y: 507.79,
    width: 239.06,
    height: 456
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M941.62,31.38h-307.06c-33.18,0-60.34,10.13-60.34,22.5v528.36c0,12.38,27.15,22.5,60.34,22.5h307.06c33.18,0,60.34-10.13,60.34-22.5V53.88c0-12.38-27.15-22.5-60.34-22.5ZM806.66,431.71c0,2.46-5.4,4.48-12,4.48h-13.14c-6.6,0-12-2.01-12-4.48v-227.31c0-2.46,5.4-4.48,12-4.48h13.14c6.6,0,12,2.01,12,4.48v227.31Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 574.22,
    y: 448.99,
    width: 182.3,
    height: 514.05
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1001.96 963.79 819.66 963.79 716.07 605.5 898.36 605.5 1001.96 963.79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1019.58,
    y: 31.38,
    width: 385.56,
    height: 87.84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1422.75,
    y: 738.41,
    width: 227.24,
    height: 227.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrj1);
export default __webpack_public_path__ + "static/media/prj_1.e790855c87a5c9eef1805af415e0cb88.svg";
export { ForwardRef as ReactComponent };